import SecureNetwork from "./SecureNetwork";

export default SecureNetwork;
